<template>
  <div>
    <el-drawer
      :with-header="false"
      :visible.sync="drawer"
      direction="rtl"
      append-to-body
      size="60%">
      <div class="ai-assistant-container">
        <div class="ai-button-column">
          <i class="ai-button collapse el-icon-d-arrow-right" @click="drawer = !drawer"></i>
        </div>
        <div class="ai-iframe-container">
          <iframe
            v-if="drawer"
            class="ai-iframe"
            :src="linkUrl"
            title="AI助手"
            frameborder="0"
            referrerpolicy="no-referrer"
            allowfullscreen
          />
        </div>
      </div>
    </el-drawer>

    <div style="position: relative;" @click="drawer = !drawer">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      drawer: false,
    }
  },
  props: {
    linkUrl: {
      type: String,
      default: ''
    }
  },
  created() {

  },
  methods: {

  }
}

</script>

<style scoped lang="scss">

/deep/ .el-drawer__body {
  height: 100%;
  overflow: hidden;
}

.ai-assistant-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: stretch;
}

.ai-button-column {
  width: 40px;
  height: 100%;
  position: relative;
  overflow: visible;
}

.ai-iframe-container {
  background-color: #fff;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.ai-iframe {
  width: 100%;
  height: 100%;
  border: 0;
}

.ai-button {
  width: 40px;
  height: 75px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  background-color: #fff;
  border: 0;
  color: #00AEEC;
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  cursor: pointer;
  z-index: 1;
  box-sizing: border-box;
}

</style>
